import {Howl, Howler} from "howler";
import * as PIXI from "pixi.js";
import {DeviceDetector} from "../DeviceDetector";
import {ButtonState} from "./ButtonState";

export class Button extends PIXI.Sprite {

    public static readonly BUTTON_EVENTS = {
        POINTER_OVER: "pointerover",
        POINTER_OUT: "pointerout",
        POINTER_DOWN: "pointerdown",
        POINTER_UP: "pointerup",
        POINTER_CANCEL: "pointercancel",
        POINTER_UP_OUTSIDE: "pointerupoutside",
    };
    protected baseTexture: PIXI.Texture;
    protected mouseOverTexture: PIXI.Texture;
    protected onPointerDownTexture: PIXI.Texture;
    protected inactiveTexture: PIXI.Texture;
    protected readonly DEFAULT_ANCHOR_POINT: any = new PIXI.Point(0.5, 0.5);
    private currentState: ButtonState = ButtonState.BASE;
    private _enabled: boolean = true;
    private onClickedSubscribers: Array<Function> = [];
    private sound: Howl;
    private pixiLabel: PIXI.Text;

    constructor(basePath: string, onHoverPath: string, onClickPath: string, inactivePath: string, soundPath?: string) {
        super(PIXI.Texture.fromFrame(basePath));
        this.baseTexture = PIXI.Texture.fromFrame(basePath);
        this.mouseOverTexture = PIXI.Texture.fromFrame(onHoverPath);
        this.onPointerDownTexture = PIXI.Texture.fromFrame(onClickPath);
        this.inactiveTexture = PIXI.Texture.fromFrame(inactivePath);
        this.interactive = true;
        this.buttonMode = true;
        this.anchor = this.DEFAULT_ANCHOR_POINT;
        this.addMouseOverListener();
        this.addOnMouseDownLister();

        if (soundPath) {
            this.sound = new Howl({
                src: [soundPath],
                volume: 0.8,
            });
        }
    }

    get state(): ButtonState {
        return this.currentState;
    }

    get label(): PIXI.Text {
        return this.pixiLabel;
    }

    set label(value: PIXI.Text) {
        if (this.pixiLabel) {
            this.removeChild(this.pixiLabel);
        }
        this.pixiLabel = value;
        this.addChild(this.pixiLabel);
    }

    get enabled(): boolean {
        return this._enabled;
    }

    set enabled(value: boolean) {
        this._enabled = value;
        if (this._enabled) {
            this.texture = this.baseTexture;
            this.currentState = ButtonState.BASE;
        } else {
            this.texture = this.inactiveTexture;
            this.currentState = ButtonState.INACTIVE;
        }
    }

    public subscribeOnClicked(subscriber: Function): void {
        this.onClickedSubscribers.push(subscriber);
    }

    private addMouseOverListener(): void {
        this.on(Button.BUTTON_EVENTS.POINTER_OVER, () => {
            if (this._enabled) {
                this.texture = this.mouseOverTexture;
                this.currentState = ButtonState.ON_HOVER;
            }
        });
        this.on(Button.BUTTON_EVENTS.POINTER_OUT, () => {
            if (this._enabled) {
                this.texture = this.baseTexture;
            }
        });
    }

    private addOnMouseDownLister(): void {
        this.on(Button.BUTTON_EVENTS.POINTER_DOWN, () => {
            if (this._enabled) {
                this.texture = this.onPointerDownTexture;
                this.clickListener();
                this.currentState = ButtonState.ON_CLICK;
            }
        });
        this.on(Button.BUTTON_EVENTS.POINTER_UP, () => {
            if (this._enabled) {
                if (DeviceDetector.isMobileOrTabletDevice()) {
                    this.texture = this.baseTexture;
                } else {
                    this.texture = this.mouseOverTexture;
                }
                this.currentState = ButtonState.BASE;
            }
        });
        this.on(Button.BUTTON_EVENTS.POINTER_CANCEL, () => {
            if (this._enabled) {
                this.texture = this.baseTexture;
                this.currentState = ButtonState.BASE;
            }
        });
        this.on(Button.BUTTON_EVENTS.POINTER_UP_OUTSIDE, () => {
            if (this._enabled) {
                this.texture = this.baseTexture;
                this.currentState = ButtonState.BASE;
            }
        });
    }

    private clickListener(): void {
        if (this.sound) {
            this.sound.play();
        }
        if (this._enabled) {
            this.callAllSubscribers();
        }
    }

    private callAllSubscribers(): void {
        for (let i = 0; i < this.onClickedSubscribers.length; i++) {
            this.onClickedSubscribers[i]();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/controlElements/Button.ts